import React, { useEffect, useState } from "react";
import { getRandomAnimalEmoji, getStableAnimalEmoji } from "../utils/utils";

export default function AnimalEasterEggBadge({
  seed,
  ariaLabel = "Animal easter egg",
  className = "",
  stopPropagation = false,
}) {
  const [emoji, setEmoji] = useState(() => getStableAnimalEmoji(seed));
  const [runaway, setRunaway] = useState(false);
  const [pop, setPop] = useState(false);
  const [runawayStyle, setRunawayStyle] = useState({});

  useEffect(() => {
    setEmoji(getStableAnimalEmoji(seed));
    setRunaway(false);
    setPop(false);
    setRunawayStyle({});
  }, [seed]);

  const handleClick = (e) => {
    if (stopPropagation && e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (runaway) return;

    // Random direction: pick a vector big enough to go off-screen.
    const rand = (min, max) => min + Math.random() * (max - min);
    let runX = rand(-140, 140); // vw
    let runY = rand(-90, 90); // vh
    if (Math.abs(runX) < 70) runX = runX < 0 ? -70 : 70;
    if (Math.abs(runY) < 35) runY = runY < 0 ? -35 : 35;
    const rot = rand(-55, 55); // deg

    setRunawayStyle({
      "--as-run-x": `${runX}vw`,
      "--as-run-y": `${runY}vh`,
      "--as-run-rot": `${rot}deg`,
    });
    setRunaway(true);

    window.setTimeout(() => {
      setEmoji(getRandomAnimalEmoji(emoji));
      setRunaway(false);
      setPop(true);
      window.setTimeout(() => setPop(false), 240);
    }, 600);
  };

  return (
    <button
      type="button"
      className={`as-animal-icon-badge ${runaway ? "as-animal-runaway" : ""} ${
        pop ? "as-animal-pop" : ""
      } ${className}`}
      onClick={handleClick}
      aria-label={ariaLabel}
      style={runawayStyle}
    >
      {emoji}
    </button>
  );
}

